<div class="client-esign">
  <div class="client-esign__close-btn-container">
    <button class="client-esign__close-btn" type="button" (click)="closeModal()">Close</button>
  </div>
  <ng-container *ngIf="formsToSign.length">
    <div class="client-esign__header-container client-esign__header">
      <div class="client-esign__title">
        Sign your policy documents
        <span *ngIf="formsToSign.length > 1">({{ docIndex + 1 }} of {{ formsToSign.length }})</span>
      </div>

      <div class="client-esign__text" [innerHTML]="formsToSign[docIndex] && formsToSign[docIndex].textPrompt"></div>

      <div *ngIf="errorRenderingPdf" class="client-esign__text client-esign__text-error">
        An error occurred while attempting to display the policy {{ formsToSign[docIndex].formType | lowercase }} form.
      </div>
      <div *ngIf="errorSigningPdf" class="client-esign__text client-esign__text-error">
        An error occurred while attempting to sign the policy {{ formsToSign[docIndex].formType | lowercase }} form.
      </div>
    </div>
    <div class="client-esign__sign-btn-container">
      <button
        class="button button--blue button--primary client-esign__sign-btn"
        [disabled]="esignDisabled"
        (click)="signForm()"
      >
        <span *ngIf="docIndex === formsToSign.length - 1; then lastFormToSign; else moreFormsToSign"></span>
        <ng-template #lastFormToSign><span>Sign And Accept Offer</span></ng-template>
        <ng-template #moreFormsToSign><span>Sign</span></ng-template>
      </button>
    </div>
    <div class="client-esign__pdf-container" [hidden]="!pdfRendered" #pdfCanvasContainer></div>
  </ng-container>
</div>
<loading *ngIf="loadingScreen"></loading>
